import React from 'react';
import { Navigate } from 'react-router-dom';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';
import { Lock } from 'lucide-react';

const NoRolePage = () => {
  const { user, loading, permissions, logout } = useAuth();

  // Leave once the active brand grants something: after access is granted, or after BrandSync
  // moves to a brand the user holds permissions on.
  if (!loading && user && permissions.length > 0) return <Navigate to="/" replace />;

  return (
    <div className="flex items-center justify-center min-h-screen bg-surface p-4">
      <div className="w-full max-w-md p-8 text-center rounded-xl border border-white/10 bg-surface-1">
        <Lock className="h-14 w-14 mx-auto mb-4 text-ink-mute" />
        <h2 className="text-xl font-bold text-ink mb-2">No access</h2>
        {user && (
          <p className="text-sm text-ink-dim mb-1">
            Logged in as <strong className="text-ink">{user.email}</strong>
          </p>
        )}
        <p className="text-ink-dim mb-6">
          Your account doesn't have any roles assigned yet. Please contact an admin to get access.
        </p>
        <Button variant="outline" onClick={logout}>Logout</Button>
      </div>
    </div>
  );
};

export default NoRolePage;
